var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Output, Input, EventEmitter } from '@angular/core';
var ColorPickerComponent = /** @class */ (function () {
    function ColorPickerComponent() {
        // 选择颜色以后调用父组件中的方法，将数据传递出去，方法
        this.sentColor = new EventEmitter();
    }
    // 当选择颜色以后
    ColorPickerComponent.prototype.colorPickerChangeFun = function () {
        this.sentColor.emit(this.color);
    };
    __decorate([
        Input()
    ], ColorPickerComponent.prototype, "disabled", void 0);
    __decorate([
        Input()
    ], ColorPickerComponent.prototype, "color", void 0);
    __decorate([
        Output()
    ], ColorPickerComponent.prototype, "sentColor", void 0);
    ColorPickerComponent = __decorate([
        Component({
            selector: 'color-picker',
            styles: [".color-picker-content { width: 100%; height: 100%; position: relative; } .transparent { position: absolute; width: 100%; height: 100%; background: url(\"/assets/common/images/colorPicker/transparent.png\"); z-index: 1; left: 0; top: 0; } .color-picker { border: 1px solid #EBECF0; position: absolute; z-index: 2; width: 100%; height: 100%; left: 0; top: 0; } .color-picker:focus { outline: none; box-shadow: none; } "],
            template: "<div class=\"color-picker-content\"> <div class=\"transparent\"></div> <input  class=\"color-picker\"  type=\"button\" [style.background]=\"color\"  [(colorPicker)]=\"color\" [cpOutputFormat]=\"'rgba'\"  (colorPickerChange)=\"colorPickerChangeFun()\" [cpAlphaChannel]=\"'always'\" [cpPresetColors]=\"['#e33c39', '#e96033', '#ed913a', '#f0af41', '#f6db4d', '#acd646' , '#70c040' , '#55bfc0' , '#3d90f7', '#3358e2', '#6938c9', '#da4494', '#000000', '#bfbfbf' , '#e8e8e8' , '#ffffff']\" [disabled]= \"disabled\" /> </div> "
        })
    ], ColorPickerComponent);
    return ColorPickerComponent;
}());
export { ColorPickerComponent };
